/**
 * Cuándo vuelve a pedir el PIN.
 *
 * After fifteen minutes in which nobody touched the app, the PIN pad of whoever used it last
 * comes up over whatever was on screen: when the app is opened, when it comes back from the
 * background, or where it sits open on the counter. Fifteen is the default; the owner can make it
 * anything from one minute to an hour in «Configuración» (`bloqueoMinutos`).
 *
 * Not on every open, because a shift is dozens of interruptions — a reload for an update, a
 * trip to WhatsApp to send a receipt, a cheap phone killing the app while it is out of sight —
 * and a PIN after each of those gets written on a sticky note beside the till. But not never,
 * either, which is what it used to be: a phone picked up in the morning was still signed in as
 * whoever closed the night before, with the owner's reports if that was the owner. Fifteen
 * idle minutes is about where the person holding the phone stops being a safe guess.
 *
 * The time of the last touch belongs to this device and is needed before anything else at
 * start-up, so it lives in localStorage. Where storage is unavailable the answer is to ask.
 */

/** Until the shop says otherwise: the default of `bloqueoMinutos`. */
export const MINUTOS_SIN_USO = 15;

const CLAVE = 'abastece.ultimoUso';

export function marcarUso(ahora = Date.now()): void {
  try {
    localStorage.setItem(CLAVE, String(ahora));
  } catch {
    // Nowhere to keep it: the next start asks for the PIN, which is the safe side to fail on.
  }
}

export function ultimoUso(): number | null {
  try {
    const valor = Number(localStorage.getItem(CLAVE));
    return valor > 0 ? valor : null;
  } catch {
    return null;
  }
}

/** A clock that went backwards counts as a long time: nobody can say how long it really was. */
export function hayQuePedirPin(
  ultimo: number | null,
  ahora: number,
  minutos: number = MINUTOS_SIN_USO,
): boolean {
  return ultimo === null || ahora < ultimo || ahora - ultimo >= minutos * 60_000;
}
